module.exports = __webpack_public_path__ + "static/media/27OCHA18.b826deba.jpg";